import UserIntro from './UserIntro'

export default UserIntro
